export function compareText(one = '', other = ''): number {
  if (one === other) return 0;

  const oneLowercase = one.toLowerCase();
  const otherLowercase = other.toLowerCase();

  return oneLowercase < otherLowercase ? -1 : 1;
}
